import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import useAuthPatient from "src/Patient/hooks/useAuthPatient";
import useSavePatient from "src/Patient/hooks/useSavePatient";
import { errorsReservationGuestState, valuesFormRegisterState, valuesFormReservationGuestImagenologiaState } from "src/Patient/state/atoms";
import ReservationService from "src/services/agenda/reservations";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { snackbarState } from "src/store/global/snackbarState";
import { hourSelectedState, showModalReservationState , professionalSelectedState } from "src/store/reservation/reservationState";
import { userState } from "src/store/user/userState";
import { ReservationSchemaImagenologia } from "../schemas/ReservationSchemaImagenologia";
import { activeTabReservationState } from "../state/atoms";

import { filterSearchSelectedState } from "../../SearchHours/state/atoms";

export const useSaveReservationImagenologia = () => {
    const { catchErrorApi } = useCatchErrorApi();
    //const history = useNavigate();
    const navigate = useNavigate();
    const [loadingSaved, setLoadingSaved] = useState(false);
    const [hourSelected, setHourSelected] = useRecoilState(hourSelectedState);

    const [professionalSelected, setProfessionalSelected] = useRecoilState(professionalSelectedState);
    
    const setSnackbar = useSetRecoilState(snackbarState);
    const [showModal, setShowModal] = useRecoilState(showModalReservationState);
    const activeTabReservation = useRecoilValue(activeTabReservationState);
    const setErrorsReservationGuest = useSetRecoilState(errorsReservationGuestState);
    const [valuesFormReservationGuest, setValuesFormReservationGuest] = useRecoilState(valuesFormReservationGuestImagenologiaState);
    const valuesFormRegister = useRecoilValue(valuesFormRegisterState)
    const user = useRecoilValue(userState);
    const { handleLoginUser } = useAuthPatient();
    const { handleValidatePhones } = useSavePatient()

    const filterSearchSelected = useRecoilValue(filterSearchSelectedState);

    const handleClickSaveReservation = async () => {
        setLoadingSaved(true);

        let restPropertiesReservation = {};
        let userStorage = user.payload || null;
        let findErrors = false;

        console.log("CONFIRMAR RESERVA!!!");
        let tipoExamen = filterSearchSelected.tipoExamenSelected.code;
        // let agePrsCorrel = filterSearchSelected.examenSelected.code;
        // console.log(`TIPOEXAMEN : ${tipoExamen}  | EXAMEN : ${agePrsCorrel}`);
        let ageExaCorrel = filterSearchSelected.examenSelected.code;
        console.log(`TIPOEXAMEN : ${tipoExamen}  | EXAMEN : ${ageExaCorrel}`);
        try {
            let dataForReservation = {
                ptdRut: hourSelected?.professional?.ptdRut,
                agpCorrel: hourSelected?.hourSelected?.agpCorrel,
                ageCorrel: hourSelected?.hourSelected?.ageCorrel,
                cmnCodigo: hourSelected?.hourSelected?.cmnCodigo,
                ageOrigen: 'W',
                ageExaCorrel: ageExaCorrel
            }

            if (activeTabReservation === '1' && !user.isAuthenticated) {
                const userLogin = await handleLoginUser();
                userStorage = { ...userLogin }
            }

            if (activeTabReservation === '2' && !user.isAuthenticated) {
                const reservationSchemaImagenologia = new ReservationSchemaImagenologia();
                const bodyValidate = await reservationSchemaImagenologia.isValidSchema({ ...valuesFormReservationGuest });
                const emailErrors = valuesFormReservationGuest.ageEmail !== valuesFormReservationGuest.ageEmailConfirm
                findErrors = await handleValidatePhones() || emailErrors;
                
                if (bodyValidate.ok === false || findErrors) {
                    findErrors = true;
                    setErrorsReservationGuest((currentState) => ({
                        ...currentState,
                        ...bodyValidate.dataErrors,
                        ageEmailConfirm: emailErrors ? ["El correo electrónico no coincide"] : []
                    }))
                }


                if (findErrors) return;

                restPropertiesReservation = {
                    ...valuesFormReservationGuest,
                    usuFono: valuesFormRegister['uswFonoFijo1'],
                    usuCelular: valuesFormRegister['uswFonoMovil']
                }
            }
            if (userStorage) {
                restPropertiesReservation = {
                    "uprRut": userStorage.uswRut,
                    "usuNombres": userStorage.uswNombres,
                    "usuApePat": userStorage.uswApePat,
                    "usuApeMat": userStorage.uswApeMat === "" || !userStorage.uswApeMat ? null : userStorage.uswApeMat,
                    "usuCelular": userStorage.uswFonoMovil,
                    "usuFono": userStorage.usuFonoCompleto,
                    "ageEmail": userStorage.uswEmail,
                    "fechaNac": userStorage.fechaNac ? userStorage.fechaNac.split(" ")[0].split("-").reverse().join("-") : null
                }
            }

            dataForReservation = {
                ...dataForReservation,
                ...restPropertiesReservation,
            }

            await ReservationService.saveReservationImagenologia(dataForReservation);
            setSnackbar({
                openAlert: true,
                text: "Su hora ha sido agendada correctamente",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });

            setHourSelected((currentState) => ({
                ...currentState,
                emailPaciente: dataForReservation.ageEmail
            }))
            
            setShowModal(false);
            //history.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/reserva-exitosa`)
            navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/reserva-exitosa`);
            // window.open(`${process.env.REACT_APP_REDIRECT_WEB}reserva-exitosa`, '_blank');

        } catch (error) {
            console.log("ERROR => ", error);
            //setShowModal(false);
            catchErrorApi(error);

            if(error.ok != false){
                setShowModal(false);                
                setTimeout( () => window.location.reload(false) , 1500 );
            }
            //setTimeout( () => window.location.reload(false) , 1500 );
        } finally {
            //setShowModal(false);
            setLoadingSaved(false)
        }
    }

    return {
        handleClickSaveReservation,
        loadingSaved,
        setLoadingSaved,
        hourSelected,
        setHourSelected,
        professionalSelected,
        setProfessionalSelected,
        showModal,
        setShowModal,
        activeTabReservation,
        setErrorsReservationGuest,
        valuesFormReservationGuest,
        setValuesFormReservationGuest
    }
}